module.exports = __webpack_public_path__ + "static/img/ip_logo.40147d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/ip_logo.png
// module id = gd+B
// module chunks = 66